export default __webpack_public_path__ + "static/media/Flag_of_Egypt.f056c62d.svg";